<template>
  <section id="cookies">
    <div id="bloqueSuperior">
      <div id="bloqueSuperior__texto">
        <p id="bloqueSuperior__texto--cookies">COOKIES</p>
        <p id="bloqueSuperior__texto--descripcion">
          En esta Política de Cookies encontrarás información sobre el uso que
          realizamos de las cookies y dispositivos similares que instalan los
          terminales de nuestros clientes y usuarios.
        </p>
      </div>
    </div>
    <div id="Cookies" class="modal-content">
      <div class="divModalInterno">
        <p class="textoCentradoModal">
          <strong class="fontBold"><u>POL&Iacute;TICA DE COOKIES</u></strong>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          En esta Pol&iacute;tica de Cookies encontrar&aacute;s
          informaci&oacute;n sobre el uso que realizamos de las cookies y
          dispositivos similares que se instalan en los terminales de nuestros
          clientes y usuarios. En ocasiones, el uso de cookies puede estar
          relacionado con el tratamiento de datos personales, por lo que te
          recomendamos que consultes nuestra Pol&iacute;tica de Privacidad.
        </p>
        <p class="fontBook">
          <strong class="fontBold">INFORMACI&Oacute;N SOBRE COOKIES </strong>
        </p>
        <p>
          <strong class="fontBold">1. &iquest;</strong
          ><strong class="fontBold">Qu&eacute; es una Cookie?</strong>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Una Cookie es un peque&ntilde;o fichero de texto que un sitio web, app
          u otra Web almacena en tu ordenador, tableta, tel&eacute;fono
          inteligente o cualquier otro dispositivo similar, con
          informaci&oacute;n sobre tu navegaci&oacute;n o uso, como una etiqueta
          que identifica tu dispositivo.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Las Cookies son necesarias por ejemplo para facilitar la
          navegaci&oacute;n y conocer la manera en que interact&uacute;an los
          usuarios con las Webs, de manera que puedan ser mejoradas.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Tambi&eacute;n son muy &uacute;tiles para poder ofrecer publicidad
          seg&uacute;n las preferencias del usuario, as&iacute; como para otras
          finalidades que se detallan m&aacute;s adelante. Las Cookies no
          da&ntilde;an tu ordenador o dispositivo.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Cuando hablamos de "Cookies" tambi&eacute;n nos referimos a otras
          tecnolog&iacute;as similares de instalaci&oacute;n y/o recogida de
          informaci&oacute;n en o sobre tu dispositivo (tales como flash
          cookies, web beacons o bugs, pixels, HTML5 (de almacenamiento local),
          y tecnolog&iacute;as SDK para formatos app. Asimismo, el
          t&eacute;rmino &ldquo;Cookies&rdquo; tambi&eacute;n resulta de
          aplicaci&oacute;n al uso de t&eacute;cnicas de fingerprinting, es
          decir, aquellas t&eacute;cnicas de combinaci&oacute;n de
          informaci&oacute;n que nos ayudan a identificar tu dispositivo. En
          ocasiones, estas tecnolog&iacute;as funcionan de manera conjunta con
          cookies para recopilar y almacenar informaci&oacute;n, bien para
          proporcionarte ciertas funcionalidades o servicios en nuestra Web, o
          bien para mostrarte publicidad en las Webs de terceros, teniendo en
          cuenta tu navegaci&oacute;n.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Esta explicaci&oacute;n es una muestra general de lo que se entiende
          por Cookies a meros efectos informativos. Las Cookies que utilizamos
          de manera espec&iacute;fica se detallan en el
          <u class="fontBold panelCookies">panel de configuraci&oacute;n</u> de
          cookies accesible en nuestra Web.
        </p>
        <p>
          <strong class="fontBold"
            >2. &iquest;Qu&eacute; tipos de Cookies existen?</strong
          >
        </p>
        <ul class="listaLetras">
          <li class="fontBook">
            Cookies propias: Son aquellas que se env&iacute;an al ordenador o
            dispositivo del usuario desde un equipo o dominio gestionado por el
            propio editor, y desde el que se ofrece la Web o el servicio
            solicitado por el usuario.
          </li>
          <li class="fontBook">
            Cookies de tercero: Son aquellas que se env&iacute;an al ordenador o
            dispositivo del usuario desde un equipo o dominio que no es
            gestionado por el editor, sino por otra entidad que trata los datos
            obtenidos a trav&eacute;s de las cookies. En funci&oacute;n de la
            finalidad de la Cookie, pueden clasificarse en:
            <ul class="listaLetras">
              <li class="fontBook">
                <strong
                  >Cookies estrictamente necesarias (t&eacute;cnicas):</strong
                >Son aquellas que permiten al usuario la navegaci&oacute;n a
                trav&eacute;s de una p&aacute;gina web, Web o aplicaci&oacute;n
                y la utilizaci&oacute;n de las diferentes opciones o servicios
                que en 15 ellas existan como, por ejemplo, controlar el
                tr&aacute;fico, identificar datos o la sesi&oacute;n, acceder a
                secciones o contenidos de acceso restringido, recordar los
                elementos que integran un pedido, realizar el proceso de compra
                de un pedido, gestionar el pago, controlar el fraude vinculador
                a la seguridad del servicio, utilizar elementos de seguridad
                durante la navegaci&oacute;n, realizar la solicitud de
                inscripci&oacute;n o participaci&oacute;n en un evento,
                almacenar contenidos para la difusi&oacute;n de videos o sonido,
                habilitar contenidos din&aacute;micos (por ejemplo,
                animaci&oacute;n de carga de un texto o imagen) o compartir
                contenidos a trav&eacute;s de redes sociales. Las cookies
                t&eacute;cnicas, al ser estrictamente necesarias, se descargan
                por defecto cuando permitan mostrar la Web o prestar el servicio
                solicitado por el usuario.
              </li>
              <li class="fontBook">
                <strong class="fontBold"
                  >Cookies de funcionalidad o personalizaci&oacute;n:</strong
                >Estas cookies son aquellas que permiten recordar
                informaci&oacute;n para que el usuario acceda al servicio o Web
                con determinadas caracter&iacute;sticas que pueden diferenciar
                su experiencia de la de otros usuarios, como, por ejemplo, el
                idioma, el n&uacute;mero de resultados a mostrar cuando el
                usuario realiza una b&uacute;squeda, el aspecto o contenido del
                servicio en funci&oacute;n del tipo de navegador usado por el
                usuario o de la regi&oacute;n desde la que accede al servicio,
                etc. El no aceptar estas Cookies puede generar un rendimiento
                lento de la p&aacute;gina web o recomendaciones mal adaptadas.
              </li>
              <li class="fontBook">
                <strong class="fontBold">Cookies de an&aacute;lisis:</strong>Son
                aquellas que permiten cuantificar el n&uacute;mero de usuarios,
                las secciones visitadas en la Web y c&oacute;mo
                interact&uacute;an con la misma, para as&iacute; realizar la
                medici&oacute;n y an&aacute;lisis estad&iacute;stico de la
                utilizaci&oacute;n que hacen los usuarios, con el fin de
                introducir mejoras en funci&oacute;n del an&aacute;lisis de los
                datos de uso que hacen los usuarios de la Web o servicio.
              </li>
              <li class="fontBook">
                <strong class="fontBold"
                  >Cookies de publicidad comportamental:</strong
                >Son aquellas que almacenan informaci&oacute;n del
                comportamiento de los usuarios obtenida a trav&eacute;s de la
                observaci&oacute;n continuada de sus h&aacute;bitos de
                navegaci&oacute;n, lo que permite desarrollar un perfil
                espec&iacute;fico para mostrar publicidad en funci&oacute;n del
                mismo. Estas cookies permiten la gesti&oacute;n, de la forma
                m&aacute;s eficaz posible, de los espacios publicitarios que, en
                su caso, el editor haya incluido directamente o en
                colaboraci&oacute;n con terceros.
              </li>
            </ul>
          </li>
        </ul>
        <p>
          <strong class="fontBold"
            >3. &iquest;Qu&eacute; Cookies Utilizamos?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Utilizamos Cookies propias y de terceros para mejorar nuestros
          servicios y mostrarle publicidad relacionada con sus preferencias
          mediante el an&aacute;lisis de sus h&aacute;bitos de
          navegaci&oacute;n. Al continuar navegando por nuestro sitio una vez
          que ha sido informado el aviso, consideramos que acepta su uso. En
          concreto, los tipos de cookies que utilizamos son:
        </p>
        <p class="fontBook" style="padding-left: 40px">
          - Cookies de sesi&oacute;n, de registro, datos del proceso de compra
          de alguno de nuestros&nbsp; productos o servicios. <br />- Cookies de
          an&aacute;lisis. Son las que nos permiten analizar de manera
          an&oacute;nima el n&uacute;mero de visitas a nuestro sitio web y
          realizar mediciones y an&aacute;lisis estad&iacute;sticos, con el
          objeto de mejorar nuestros servicios. Pueden ser tratadas por nosotros
          o por terceros, como en el caso de Google Analitycs.
        </p>
        <p class="fontBook">Propias:</p>
        <table border="">
          <tbody>
            <tr>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Nombre</strong>
                </p>
              </td>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Empresa</strong>
                </p>
              </td>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Nombre Cookie</strong>
                </p>
              </td>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Finalidad</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p class="fontBook">alebateducation.com</p>
              </td>
              <td>
                <p class="fontBook">Alebat Education</p>
              </td>
              <td>
                <p class="fontBook">PHPSESSID / cookiesDirective /</p>
              </td>
              <td>
                <p class="fontBook">
                  Estas cookies tienen como finalidad mejorar la
                  navegaci&oacute;n por el sitio web. Unas tienen la
                  caracter&iacute;stica que son persistentes y otras
                  &uacute;nicamente de sesi&oacute;n
                </p>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="fontBook">Terceros:</p>
        <table border="" width="100%">
          <tbody>
            <tr>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Nombre</strong>
                </p>
              </td>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Empresa</strong>
                </p>
              </td>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Nombre Cookie</strong>
                </p>
              </td>
              <td>
                <p class="textoCentradoModal">
                  <strong class="fontBold">Finalidad</strong>
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p class="fontBook">Google</p>
              </td>
              <td>
                <p class="fontBook">Analytics</p>
              </td>
              <td>
                <p class="fontBook">_ga / _gid / _gat</p>
              </td>
              <td>
                <p class="fontBook">Utilizadas para Google Analytics</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p>
          <strong class="fontBold"
            >4. &iquest;Para qu&eacute; se utilizan las Cookies en nuestra
            Web?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Las Cookies son una parte esencial de c&oacute;mo funciona nuestra
          Web. El objetivo principal de nuestras Cookies es que tu experiencia
          de navegaci&oacute;n sea m&aacute;s c&oacute;moda y eficiente. Por
          ejemplo, son utilizadas para recordar tus preferencias (idioma,
          pa&iacute;s, etc.) durante la navegaci&oacute;n y en futuras visitas.
          Tambi&eacute;n usamos nuestras Cookies para mejorar nuestros servicios
          y Web continuamente, as&iacute; como para poder ofrecer publicidad
          personalizada seg&uacute;n tus h&aacute;bitos de navegaci&oacute;n.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          La informaci&oacute;n recogida en las Cookies nos permite,
          adem&aacute;s, mejorar nuestra Web mediante estimaciones sobre datos
          estad&iacute;sticos y patrones de uso (n&uacute;mero de visitas,
          secciones m&aacute;s visitadas, tiempo de visita, etc.), conocer de
          manera estad&iacute;stica c&oacute;mo interact&uacute;an los usuarios
          con la Web con el fin de mejorar nuestros servicios, as&iacute; como
          para adaptar la Web a tus intereses individuales, la
          aceleraci&oacute;n de las b&uacute;squedas, etc.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          En ocasiones, podremos utilizar Cookies para obtener
          informaci&oacute;n que nos permita mostrar desde nuestra Web, las Webs
          de terceros, o por cualquier otro medio, publicidad basada en el
          an&aacute;lisis de tus h&aacute;bitos de navegaci&oacute;n (productos
          visitados, secciones consultadas, etc.).
        </p>
        <p class="fontBook" style="padding-left: 40px">
          En todo caso, en las Cookies que utilizamos nosotros nunca almacenamos
          informaci&oacute;n sensible como contrase&ntilde;as, datos de tarjeta
          de cr&eacute;dito o d&eacute;bito, etc.
        </p>
        <p class="fontBook">
          <strong class="fontBold"
            >5. &iquest;Qui&eacute;n utiliza la informaci&oacute;n almacenada en
            las Cookies?
          </strong>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          La informaci&oacute;n almacenada en las Cookies de nuestra Web es
          utilizada exclusivamente por nosotros, a excepci&oacute;n de aquellas
          identificadas en la secci&oacute;n 2 como &ldquo;Cookies de
          terceros&rdquo;, que son utilizadas y gestionadas por entidades
          externas para proporcionarnos servicios dirigidos a mejorar nuestros
          servicios y la experiencia del usuario al navegar en nuestra Web.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          M&aacute;s informaci&oacute;n en el panel de configuraci&oacute;n de
          Cookies accesible en todo momento en nuestra Web. Para obtener
          informaci&oacute;n m&aacute;s detallada sobre el tratamiento de tus
          datos personales en nuestra colaboraci&oacute;n con terceros y
          aquellos sujetos a transferencias internacionales de datos, te
          recomendamos que leas nuestra Pol&iacute;tica de Privacidad accesible
          en nuestra Web, y las pol&iacute;ticas de privacidad / configuraciones
          de privacidad de estos terceros colaboradores accesibles a
          trav&eacute;s de sus Webs.
        </p>
        <p>
          <strong class="fontBold"
            >6. &iquest;C&oacute;mo pueden nuestros usuarios gestionar las
            cookies que utilizamos?
          </strong>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Los usuarios de ALEBAT EDUCATION pueden gestionar las cookies y, por
          lo tanto, rechazarlas de forma unitaria o en su totalidad, en el
          <strong
            ><u class="fontBold panelCookies"
              >Panel de Configuraci&oacute;n.</u
            ></strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Si se desactivan o rechazan las cookies, puede ocurrir que algunas de
          las funciones y/o servicios no funcionen adecuadamente.&nbsp;
        </p>
        <p class="fontBook" style="padding-left: 40px">
          La Web no ejerce control sobre otros sitios web mostrados como
          resultado de su b&uacute;squeda, enlaces o accesos desde nuestro
          directorio. Estos otros sitios web pueden colocar sus propias cookies
          o solicitarle informaci&oacute;n personal.
        </p>
        <p>
          <strong class="fontBold"
            >7. &iquest;C&oacute;mo pueden nuestros usuarios deshabilitar las
            cookies en los principales navegadores?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Normalmente es posible dejar de aceptar las cookies del navegador, o
          dejar de aceptar las cookies de un servicio en particular.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Todos los navegadores modernos permiten
          <strong class="fontBold"
            >cambiar la configuraci&oacute;n de cookies</strong
          >.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Estos ajustes normalmente se encuentran en las &lsquo;opciones&rsquo;
          o &lsquo;Preferencias&rsquo; del men&uacute; de su navegador.
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Aunque puede variar ligeramente de una versi&oacute;n de navegador a
          otra, la configuraci&oacute;n de la pol&iacute;tica de cookies para
          los navegadores m&aacute;s utilizados es la siguiente:
        </p>
        <ul>
          <li style="list-style-type: none">
            <ul>
              <li class="fontBook">
                <strong class="fontBold">Internet Explorer: </strong
                >Herramientas -&gt; Opciones de Internet -&gt; Privacidad -&gt;
                Configuraci&oacute;n.
              </li>
              <li class="fontBook">
                <strong class="fontBold">Firefox: </strong>Preferencias -&gt;
                Privacidad y Seguridad
              </li>
              <li class="fontBook">
                <strong class="fontBold">Chrome: </strong>Preferencias -&gt;
                Configuraci&oacute;n -&gt; Mostrar opciones avanzadas -&gt;
                Privacidad y Seguridad
              </li>
              <li class="fontBook">
                <strong class="fontBold">Safari: </strong>Preferencias -&gt;
                Privacidad.
              </li>
              <li class="fontBook">
                <strong class="fontBold">Opera: </strong>Configuraci&oacute;n
                -&gt; Privacidad y seguridad.
              </li>
            </ul>
          </li>
        </ul>
        <p class="fontBook" style="padding-left: 40px">
          Para m&aacute;s informaci&oacute;n, puede consultar el soporte o la
          ayuda de su navegador o a trav&eacute;s de los siguientes enlaces:
          <a class="enlace" href="https://support.apple.com/kb/ph17191?locale=es_ES">Safari</a
          >,
          <a class="enlace" href="https://support.google.com/chrome/answer/95647?hl=es"
            >Chrome, </a
          ><a class="enlace" 
            href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias?redirectlocale=es&amp;redirectslug=habilitar-y-deshabilitar-cookies-que-los-sitios-we"
            >Firefox, </a
          ><a class="enlace" 
            href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies"
            >Explorer, </a
          ><a class="enlace" href="https://www.opera.com/help/tutorials/security/privacy/"
            >Opera.
          </a>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Muchos navegadores permiten activar un modo privado mediante el cual
          las cookies se borran siempre despu&eacute;s de su visita. Dependiendo
          de cada navegador este modo privado, puede tener diferentes nombres. A
          continuaci&oacute;n, encontrar&aacute; una lista de los navegadores
          m&aacute;s comunes y los diferentes nombres de este &ldquo;modo
          privado&rdquo;:
        </p>
        <ul>
          <li style="list-style-type: none">
            <ul>
              <li class="fontBook">
                Internet Explorer 8 y superior - Navegaci&oacute;n Privada
              </li>
              <li class="fontBook">
                Safari 2 y superior - Navegaci&oacute;n Privada
              </li>
              <li class="fontBook">
                Opera 10.5 y superior - Navegaci&oacute;n Privada
              </li>
              <li class="fontBook">
                FireFox 3.5 y superior - Navegaci&oacute;n Privada
              </li>
              <li class="fontBook">
                Google Chrome 10 y superior &ndash; Inc&oacute;gnito
              </li>
            </ul>
          </li>
        </ul>
        <p>
          <strong class="fontBold"
            >8. &iquest;C&oacute;mo puedo deshabilitar las cookies de
            terceros?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Si se desea conocer las condiciones de privacidad y uso de cookies de
          terceros, puede acceder las pol&iacute;ticas de cookies de:
        </p>
        <ul>
          <li style="list-style-type: none">
            <ul>
              <li class="fontBook">
                Facebook:
                <a class="enlace" href="https://es-es.facebook.com/help/cookies"
                  >https://es-es.facebook.com/help/cookies</a
                >
              </li>
              <li class="fontBook">
                Twitter:
                <a class="enlace" href="https://twitter.com/privacy"
                  >https://twitter.com/privacy</a
                >
              </li>
              <li class="fontBook">
                Youtube:
                <a class="enlace" 
                  href="https://support.google.com/youtube/answer/32050?hl=es&amp;co=GENIE.Platform=Desktop"
                  >https://support.google.com/youtube/answer/32050?hl=es&amp;co=GENIE.Platform=Desktop</a
                >
              </li>
              <li class="fontBook">
                Linkedin:
                <a class="enlace" 
                  href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out?trk=microsites-frontend_legal_cookie-policy"
                  >https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out?trk=microsites-frontend_legal_cookie-policy</a
                >
              </li>
              <li class="fontBook">
                Google:
                <a class="enlace" 
                  href="https://www.google.es/intl/es/policies/technologies/cookies/"
                  >https://www.google.es/intl/es/policies/technologies/cookies/</a
                >
              </li>
            </ul>
          </li>
        </ul>
        <p>
          <strong class="fontBold"
            >9. &iquest;Qu&eacute; ocurre si no acepto las cookies de la
            web?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          En caso de que el usuario no permita la instalaci&oacute;n de cookies
          en su navegador es posible que no pueda acceder a alguna de las
          secciones de nuestro sitio web.
        </p>
        <p class="fontBook">
          <strong class="fontBold"
            >10. &iquest;Se realizan transferencias internacionales de mis
            datos?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Le informamos que ALEBAT EDUCATION realiza transferencias
          internacionales de datos:
        </p>
        <ul>
          <li style="list-style-type: none">
            <ul>
              <li class="fontBook">
                Tambi&eacute;n cuenta con otros servicios de infraestructura
                virtual de &ldquo;computaci&oacute;n en la nube&rdquo;,
                prestados por el Grupo Zoho, entidad que cuenta con
                cl&aacute;usulas contractuales tipo adheridas a las normas de
                Protecci&oacute;n de Datos de la UE (informaci&oacute;n de
                dichas cl&aacute;usulas disponible en:
                <a class="enlace" href="https://www.zoho.com/privacy/dpa/DPA_zoho_com.pdf"
                  >https://www.zoho.com/privacy/dpa/DPA_zoho_com.pdf</a
                >.Aqu&iacute; puede encontrar m&aacute;s informaci&oacute;n de
                la identidad y localizaci&oacute;n de las entidades del Grupo
                Zoho:
                <a class="enlace" href="https://www.zoho.com/es-xl/privacy/zoho-group.html"
                  >https://www.zoho.com/es-xl/privacy/zoho-group.html).
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <p class="fontBook" style="padding-left: 40px">
          En cuanto a las cookies de terceros, puedes informarte de las
          transferencias a terceros pa&iacute;ses que, en su caso, realizan los
          terceros identificados en esta pol&iacute;tica de cookies en sus
          correspondientes pol&iacute;ticas (ver los enlaces facilitados
          anteriormente).
        </p>
        <p>
          <strong class="fontBold"
            >11. &iquest;Se elabora un perfil de mi navegaci&oacute;n y se toman
            decisiones automatizadas que puedan afectarme jur&iacute;dica o
            significativamente?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Le informamos que ALEBAT EDUCATION no realiza elaboraci&oacute;n de
          perfiles de navegaci&oacute;n ni se toman decisiones automatizadas que
          puedan afectarle jur&iacute;dica o significativamente.
        </p>
        <p class="fontBook">
          <strong class="fontBold"
            >12. &iquest;Se realiza un tratamiento de mis datos
            sensibles?</strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Le informamos que ALEBAT EDUCATION no realiza tratamientos de datos
          sensible.
        </p>
        <p>
          <strong class="fontBold">13. M&aacute;s informaci&oacute;n</strong>
        </p>
        <p class="fontBook" style="padding-left: 40px">
          <strong
            >Para m&aacute;s informaci&oacute;n sobre cookies y sus derechos
            como usuario puede consultar la
            <a class="enlace" 
              href="https://www.aepd.es/sites/default/files/2020-07/guia-cookies.pdf"
              >Gu&iacute;a sobre el uso de cookies elaborada por la Agencia
              Espa&ntilde;ola de Protecci&oacute;n de Datos (AEPD)</a
            ></strong
          >
        </p>
        <p class="fontBook" style="padding-left: 40px">
          Para m&aacute;s informaci&oacute;n sobre el tratamiento de sus datos
          personales puede acceder a la
          <u class="mostrarPrivacidad dentroDeCookies"
            ><strong class="fontBold">Pol&iacute;tica de Privacidad</strong
            >&nbsp;de ALEBAT EDUCATION.
          </u>
        </p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "CookiesPrincipal",
};
</script>